import React from "react";
import Carousel from "./Carousel";

const sponsors = {
  gold: [
    { name: "Gold Sponsor 1", img: require("../image/bg1.png") },
    { name: "Gold Sponsor 2", img: require("../image/bg2.jpg") },
  ],
  silver: [
    { name: "Silver Sponsor 1", img: require("../image/bg3.jpeg") },
    { name: "Silver Sponsor 2", img: require("../image/bg4.png") },
    { name: "Silver Sponsor 3", img: require("../image/bg5.jpeg") },
  ],
  bronze: [
    { name: "Bronze Sponsor 1", img: require("../image/bg6.jpg") },
    { name: "Bronze Sponsor 2", img: require("../image/bg7.jpg") },
    { name: "Bronze Sponsor 3", img: require("../image/bg8.png") },
    { name: "Bronze Sponsor 4", img: require("../image/bg2.jpg") },
  ],
};

const SponsorCard = ({ tier, name, img }) => {
  const tierClass = {
    gold: "border-warning",
    silver: "border-secondary",
    bronze: "border-orange-500",
  }[tier];

  return (
    <div className="col-md-3 my-3 d-flex justify-content-center">
      <div className={`card border-3 ${tierClass}`} style={{ width: "16rem" }}>
        <img src={img} className="card-img-top" alt={`${name} logo`} />
        <div className="card-body text-center">
          <h5 className="card-title fw-bold">{name}</h5>
          <p className="text-muted text-capitalize">{tier} Sponsor</p>
        </div>
      </div>
    </div>
  );
};

const Sponsor = () => {
  return (
    <>
      <Carousel img="bg7.jpg" />
      <div className="container py-5">
        <div className="sponsor-slider-container mt-5">
  <h3 className="text-center mb-4">PLATINUM SPONSORS</h3>
  <div className="sponsor-slider">
    <div className="sponsor-track">
      <img
        src={require("../image/sponsors4.png")}
        alt="Sponsor Banner 1"
        className="sponsor-img"
      />
      <img
        src={require("../image/sponsors4.png")}
        alt="Sponsor Banner 2"
        className="sponsor-img"
      />
      {/* Duplicate to create a seamless loop */}
      <img
        src={require("../image/sponsors4.png")}
        alt="Sponsor Banner 1"
        className="sponsor-img"
      />
      <img
        src={require("../image/sponsors4.png")}
        alt="Sponsor Banner 2"
        className="sponsor-img"
      />
    </div>
  </div>
</div>
<div className="sponsor-slider-container mt-5">
  <h3 className="text-center mb-4">GOLD SPONSORS</h3>
  <div className="sponsor-slider">
    <div className="sponsor-track">
      <img
        src={require("../image/sponsors3.png")}
        alt="Sponsor Banner 1"
        className="sponsor-img"
      />
      <img
        src={require("../image/sponsors3.png")}
        alt="Sponsor Banner 2"
        className="sponsor-img"
      />
      {/* Duplicate to create a seamless loop */}
      <img
        src={require("../image/sponsors3.png")}
        alt="Sponsor Banner 1"
        className="sponsor-img"
      />
      <img
        src={require("../image/sponsors3.png")}
        alt="Sponsor Banner 2"
        className="sponsor-img"
      />
    </div>
  </div>
</div>
<div className="sponsor-slider-container mt-5">
  <h3 className="text-center mb-4">SILVER SPONSORS</h3>
  <div className="sponsor-slider">
    <div className="sponsor-track">
      <img
        src={require("../image/sponsors6.png")}
        alt="Sponsor Banner 1"
        className="sponsor-img"
      />
      <img
        src={require("../image/sponsors6.png")}
        alt="Sponsor Banner 2"
        className="sponsor-img"
      />
      {/* Duplicate to create a seamless loop */}
      <img
        src={require("../image/sponsors6.png")}
        alt="Sponsor Banner 1"
        className="sponsor-img"
      />
      <img
        src={require("../image/sponsors6.png")}
        alt="Sponsor Banner 2"
        className="sponsor-img"
      />
    </div>
  </div>
</div>
<div className="sponsor-slider-container mt-5">
  <h3 className="text-center mb-4">BRONZE SPONSORS</h3>
  <div className="sponsor-slider">
    <div className="sponsor-track">
      <img
        src={require("../image/sponsors5.png")}
        alt="Sponsor Banner 1"
        className="sponsor-img"
      />
      <img
        src={require("../image/sponsors7.png")}
        alt="Sponsor Banner 2"
        className="sponsor-img"
      />
      {/* Duplicate to create a seamless loop */}
      <img
        src={require("../image/sponsors5.png")}
        alt="Sponsor Banner 1"
        className="sponsor-img"
      />
      <img
        src={require("../image/sponsors7.png")}
        alt="Sponsor Banner 2"
        className="sponsor-img"
      />
    </div>
  </div>
</div>
       {/* <h1 className="text-center mb-5">Our Sponsors</h1> */}
        <div className="table-responsive mb-5">
  <h3 className="text-center mb-3">SPONSORSHIP Opportunities</h3>
  <table className="table table-bordered text-center align-middle">
    <thead className="table-light">
      <tr>
        <th>Category</th>
        <th>Amount</th>
        <th>Take-Away</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Platinum</td>
        <td>₹ 6,00,000</td>
        <td>8 Delegates, Logo on all conference banners and at various event venues, handouts, Announcement about at all event venues, Stall</td>
      </tr>
      <tr>
        <td>Gold</td>
        <td>₹ 4,50,000</td>
        <td>5 Delegates, Logo on all conference banners and at various event venues, handouts, Announcement about at all event venues, Stall</td>
      </tr>
      <tr>
        <td>Silver</td>
        <td>₹ 3,00,000</td>
        <td>3 Delegates, Logo on all conference banners and at various event venues, handouts, Announcement about at all event venues, Stall</td>
      </tr>
      <tr>
        <td>Bronze</td>
        <td>₹ 1,50,000</td>
        <td>2 Delegates, Logo on all conference banners and at various event venues, handouts, Announcement about at all event venues, Stall</td>
      </tr>
    </tbody>
  </table>
</div>

<div className="table-responsive mb-5">
  <h3 className="text-center mb-3">Other SPONSORSHIP Opportunities</h3>
  <table className="table table-bordered text-center align-middle">
    <thead className="table-light">
      <tr>
        <th>SNo</th>
        <th>Details</th>
        <th>Fees (INR)</th>
        <th>Free Delegates</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>1</td>
        <td>Culinary Sponsors</td>
        <td>₹ 3,00,000</td>
        <td>4</td>
      </tr>
      <tr>
        <td>2</td>
        <td>Conference Kits</td>
        <td>₹ 2,00,000</td>
        <td>3</td>
      </tr>
      <tr>
        <td>3</td>
        <td>Pen drives (USB)</td>
        <td>₹ 1,00,000</td>
        <td>2</td>
      </tr>
    </tbody>
  </table>
</div>

<div className="table-responsive mb-5">
  <h3 className="text-center mb-3">Souvenir Advertisement Opportunities</h3>
  <table className="table table-bordered text-center align-middle">
    <thead className="table-light">
      <tr>
        <th>Page</th>
        <th>Fees (INR)</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Inside Back*</td>
        <td>₹ 50,000</td>
      </tr>
      <tr>
        <td colSpan="2" className="fw-bold">Other Inside Pages</td>
      </tr>
      <tr>
        <td>Full Page (24cm X 17cm)</td>
        <td>₹ 25,000</td>
      </tr>
      <tr>
        <td>Half Page (11cm X 17cm)</td>
        <td>₹ 15,000</td>
      </tr>
      <tr>
        <td>Quarter Page (6cm X 17cm)</td>
        <td>₹ 8,000</td>
      </tr>
    </tbody>
  </table>
  <div className="mt-5">
  <p className="fw-bold">Taxes @ GST additional, All amounts are in INR (Indian Rupees)</p>
  <p>*There shall be only one sponsoring entity for this item. Please check the website or with the organizers if you wish to sponsor these items.</p>

  <h5 className="mt-4">Contact Us for Sponsorship Queries:</h5>
  <ul className="list-unstyled">
    <li><strong>Mail:</strong> technical.secretary1@ilce.in</li>
    <li><strong>Mail:</strong> accounts@ilce.in</li>
    <li><strong>Phone:</strong> 7305040838</li>
  </ul>
</div>

</div>


<div className="sponsor-slider-container mt-5">
  <h3 className="text-center mb-4">PAST SPONSORS / PARTNERS</h3>
  <div className="sponsor-slider">
    <div className="sponsor-track">
      <img
        src={require("../image/sponsors1.png")}
        alt="Sponsor Banner 1"
        className="sponsor-img"
      />
      <img
        src={require("../image/sponsors2.png")}
        alt="Sponsor Banner 2"
        className="sponsor-img"
      />
      {/* Duplicate to create a seamless loop */}
      <img
        src={require("../image/sponsors1.png")}
        alt="Sponsor Banner 1"
        className="sponsor-img"
      />
      <img
        src={require("../image/sponsors2.png")}
        alt="Sponsor Banner 2"
        className="sponsor-img"
      />
    </div>
  </div>
</div>


        {/* Gold Sponsors */}
        {/* <section className="mb-5">
          <h2 className="text-warning text-center mb-4">Gold Sponsors</h2>
          <div className="row justify-content-center">
            {sponsors.gold.map((s, idx) => (
              <SponsorCard key={idx} tier="gold" name={s.name} img={s.img} />
            ))}
          </div>
        </section> */}

        {/* Silver Sponsors */}
        {/* <section className="mb-5">
          <h2 className="text-secondary text-center mb-4">Silver Sponsors</h2>
          <div className="row justify-content-center">
            {sponsors.silver.map((s, idx) => (
              <SponsorCard key={idx} tier="silver" name={s.name} img={s.img} />
            ))}
          </div>
        </section> */}

        {/* Bronze Sponsors */}
        {/* <section className="mb-5">
          <h2 className="text-muted text-center mb-4">Bronze Sponsors</h2>
          <div className="row justify-content-center">
            {sponsors.bronze.map((s, idx) => (
              <SponsorCard key={idx} tier="bronze" name={s.name} img={s.img} />
            ))}
          </div>
        </section> */}
      </div>
    </>
  );
};

export default Sponsor;
